import useSkills from "hooks/useSkills";
import { ChangeEvent, FormEvent, memo, useMemo, useState } from "react";
import { CreateEmployerJob } from "types/employer.interface";

interface Props {
  onNext: () => void;
  onBack: () => void;
  input: CreateEmployerJob;
  onChange: (
    e:
      | ChangeEvent<HTMLInputElement>
      | ChangeEvent<HTMLSelectElement>
      | ChangeEvent<HTMLTextAreaElement>
      | {
          target: {
            name: string;
            value: string | number;
          };
        }
  ) => void;
  onChangeByNameValue: (name: keyof CreateEmployerJob, value: any) => void;
}

function Skills({
  onNext,
  input,
  onChange,
  onChangeByNameValue,
  onBack,
}: Props) {
  const { data: skills } = useSkills(input.category);
  const [selectedSkills, setSelectedSkills] = useState<string[]>(
    input.requiredSkills || []
  );

  const submitHandler = async (e: FormEvent) => {
    e.preventDefault();
    onChangeByNameValue("requiredSkills", selectedSkills);
    onNext();
  };

  const skillsData = useMemo(() => {
    return skills?.data.map((cat) => ({
      label: cat.name,
      value: cat.name,
    }));
  }, [skills?.data]);

  const hanldeSkill = (skill: string) => {
    if (selectedSkills.includes(skill)) {
      const updated = selectedSkills.filter((item) => item !== skill);

      setSelectedSkills(updated);
      // onChangeByNameValue("requiredSkills", u.toString());
    } else {
      setSelectedSkills(selectedSkills.concat(skill));
    }
  };

  return (
    <div className="w-full ">
      <form onSubmit={submitHandler} className=" flex flex-col gap-8 ">
        <div className="flex flex-col gap-1">
          <h2 className=" font-body font-medium text-lg lg:text-xl leading-5 text-body">
            What are the required skills
          </h2>
        </div>

        <div className="flex flex-col gap-2 w-full">
          <label htmlFor="requiredSkills">Required Skills </label>

          <div className="flex gap-4 flex-wrap mt-2">
            {skillsData?.map((item, i: number) => {
              return (
                <button
                  type="button"
                  onClick={() => hanldeSkill(item.value)}
                  className={`py-2 px-4 w-fit  relative  flex items-center justify-center text-center text-background ${
                    selectedSkills.includes(item.value)
                      ? "bg-blue-500"
                      : " bg-transparent border border-border text-body text-sm font-medium"
                  } rounded`}
                  key={item.label}
                >
                  {item.label}
                </button>
              );
            })}
          </div>
        </div>

        <div className="flex items-center gap-4 mt-4">
          <button onClick={onBack} className=" px-10">
            Back
          </button>
          <button className="px-4 py-2 text-sm rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 transition-colors">
            Next
          </button>
        </div>
      </form>
    </div>
  );
}

export default memo(Skills);
